export interface IEFTPaymentDetails {
  countryName: string;
  accountHolderName: string;
  bankName: string;
  swiftAddress: string;
  accountNumber: string;
  branchCode: string;
}
